import {
  governance_tabs,
  summary_cards,
  bridge_chips,
  framework_cards,
  maturity_rows,
  committee_type_options,
  committee_cadence_options,
  committee_status_options,
  decision_status_options,
  action_status_options,
  accountability_status_options,
  calendar_type_options,
  calendar_status_options,
  consequence_severity_options,
  consequence_status_options
} from './governance_overview_data';
import {
  committee_cards,
  decision_rows,
  action_rows,
  accountability_rows,
  calendar_rows,
  consequence_rows
} from './governance_seed_data';
import { create_empty_committee_form, create_empty_decision_form, clone_committee_cards } from './governance_builders';
import { build_decision_drawer } from './governance_decision_drawer';
import { governance_methods } from './governance_methods';
import { governance_mounted, governance_before_destroy, governance_watch } from './governance_ui';

export default {
  name: 'ComplyonGovernance',
  data: () => ({
    governance_tabs,
    summary_cards,
    bridge_chips,
    framework_cards,
    maturity_rows,
    committee_cards: clone_committee_cards(committee_cards),
    committee_type_options,
    committee_cadence_options,
    committee_status_options,
    committee_modal_open: false,
    committee_modal_mode: 'create',
    committee_modal_index: null,
    committee_modal_form: create_empty_committee_form(),
    governance_modal_open: false,
    governance_modal_kind: 'decision',
    governance_modal_mode: 'create',
    governance_modal_index: null,
    governance_modal_form: create_empty_decision_form(),
    active_decision_drawer_ref: null,
    active_decision_drawer_index: null,
    decision_status_options,
    action_status_options,
    accountability_status_options,
    calendar_type_options,
    calendar_status_options,
    consequence_severity_options,
    consequence_status_options,
    decision_rows,
    action_rows,
    accountability_rows,
    calendar_rows,
    consequence_rows,
    committee_card_seq: committee_cards.length,
    decision_row_seq: decision_rows.length,
    action_row_seq: action_rows.length,
    accountability_row_seq: accountability_rows.length,
    calendar_row_seq: calendar_rows.length,
    consequence_row_seq: consequence_rows.length,
    active_tab: 'overview'
  }),
  computed: {
    any_modal_open() {
      return this.committee_modal_open || this.governance_modal_open || this.active_decision_drawer_index !== null;
    },
    committee_items() {
      return this.committee_cards.map((card) => ({ ...card, tab_id: 'committees' }));
    },
    active_decision_row() {
      if (this.active_decision_drawer_index !== null && this.decision_rows[this.active_decision_drawer_index]) {
        return this.decision_rows[this.active_decision_drawer_index];
      }

      return this.decision_rows.find((row) => row.ref === this.active_decision_drawer_ref) || null;
    },
    active_decision_drawer() {
      return build_decision_drawer(this.active_decision_row);
    }
  },
  methods: governance_methods,
  mounted: governance_mounted,
  beforeDestroy: governance_before_destroy,
  watch: governance_watch
};
